export default __webpack_public_path__ + "static/llanddwn-17b5e5d238cfd1350672d08c47850b2f.jpg";